import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TrafficNewsOption } from 'src/app/modules/traffic-news/models/traffic-news-model';
import { MapsHotelsService } from '../../services/maps-hotels/maps-hotels.service';
import { RoutePlanerEventTracker } from 'src/app/core/events/events';
import { EventsService } from 'src/app/core/services/events.service';

@Component({
    selector: 'aa-map-options',
    templateUrl: './map-options.component.html',
    styleUrls: ['./map-options.component.scss'],
    standalone: false
})

export class MapOptionsComponent {

  @Output() optionSelected: EventEmitter<any> = new EventEmitter();
  @Input() optionData: Array<TrafficNewsOption>;

  constructor(private mapsHotelService: MapsHotelsService, private eventsService: EventsService) { }

  updateCheckedOptions(option, event) {
    this.optionSelected.emit(this.optionData);
  }

  onChangeMapLayers(event: any, valType: string) { }

  copyText() {
    this.eventsService.dispatch(RoutePlanerEventTracker.TAG_LINK);

    const mapInstance = this.mapsHotelService.googleMap;
    const langMap = mapInstance.getCenter();
    const zoomLevel = mapInstance.getZoom();
    const mapUrl = `http://www.theaa.com/maps/index.jsp?lat=${langMap.lat()}&lon=${langMap.lng()}&z=${zoomLevel}`;
    const selBox = document.createElement('textarea');
      selBox.style.position = 'fixed';
      selBox.style.left = '0';
      selBox.style.top = '0';
      selBox.style.opacity = '0';
      selBox.value = mapUrl;
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      document.execCommand('copy');
      document.body.removeChild(selBox);
      const tootltip = document.getElementsByClassName('tooltipShow')[0] as HTMLElement;
      tootltip.style.display = 'block';
      setTimeout(() => {
        tootltip.style.display = 'none';
      }, 2000);
    }
    
    trackByFn(index: number): number {
      return index;
    }
  }
